import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xinjian",
  "use": "icon-xinjian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xinjian\"><defs><style type=\"text/css\"></style></defs><path d=\"M496.512 185.088H217.152v653.12h589.696V486.912H896v440.768H128v-832h368.512v89.408z m177.024 41.856V96h89.152v130.944h130.56v89.408h-130.56V447.36h-89.152V316.352h-130.56V226.944h130.56z\" p-id=\"9633\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol